import { render, staticRenderFns } from "./unread-notification-dot.vue?vue&type=template&id=7b87ea6d&"
import script from "./unread-notification-dot.vue?vue&type=script&lang=js&"
export * from "./unread-notification-dot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports